/* eslint-disable no-console */
export default {
  methods: {
    calculate(hotel, request) {
      const result = {
        success: true,
        hints: [],
        rooms: [],
        nights: -1
      };

      const arrival = this.$moment(request.arrival);
      const departure = this.$moment(request.departure);

      result.nights = departure.diff(arrival, 'days');

      let guests = request.adults;
      for (let i = 0; i < request.children.length; i += 1) {
        const child = request.children[i];
        guests += child.count;
      }

      if (guests === 0) {
        result.success = false;
        result.hints.push('Sie müssen mindestens eine Reisende angeben um die Preise berechnen zu können!');
      }
      if (arrival.isSame(departure)) {
        result.success = false;
        result.hints.push('Ankunft und Abreise befindet sich an den selben Tag.');
      }
      if (departure.isBefore(arrival)) {
        result.success = false;
        result.hints.push('Abreise muss nach Ankunft erfolgen.');
      }

      if (result.success) {
        for (let i = 0; i < hotel.kognitivHotelRooms.length; i += 1) {
          const kognitivRoom = hotel.kognitivHotelRooms[i];
          if (!kognitivRoom.ignore) {
            const room = {
              externalId: kognitivRoom.externalId,
              name: kognitivRoom.name,
              maxOccupancy: kognitivRoom.maxOccupancy,
              position: kognitivRoom.position,
              hints: [],
              ratePlans: [],
              available: true,
              tooSmall: false
            };

            if (guests > kognitivRoom.maxOccupancy) {
              room.tooSmall = true;
              room.available = false;
              room.hints.push('Belegung auf mehrere Zimmer aufteilen.');
            } else {
              for (let j = 0; j < kognitivRoom.kognitivRatePlans.length; j += 1) {
                const kognitivRatePlan = kognitivRoom.kognitivRatePlans[j];
                const ratePlan = {
                  ratePlanCode: kognitivRatePlan.ratePlan,
                  name: kognitivRatePlan.name,
                  position: kognitivRatePlan.position,
                  hints: [],
                  adults: 0,
                  additional: undefined,
                  children: [],
                  count: {
                    additional: 0,
                    children: 0,
                  },
                  total: 0
                };

                this.calculateRatePlan(result, hotel, room, kognitivRatePlan, ratePlan,
                  arrival, departure, request);

                if (room.available) {
                  room.ratePlans.push(ratePlan);
                } else if (room.hints.length === 0) {
                  room.hints.push('Zimmer hat keine ausreichende Verfügbarkeit.');
                }
              }
            }
            result.rooms.push(room);
          }
        }
      }

      return result;
    },
    calculateRatePlan(result, hotel, room, kognitivRatePlan, ratePlan, arrival, departure, request) {
      const dynamicDays = [];
      // GET RELEVANT DAYS
      for (let i = 0; i < kognitivRatePlan.dynamicDays.length; i += 1) {
        const day = kognitivRatePlan.dynamicDays[i];
        const from = this.$moment(day.from);
        if (from.isBetween(arrival, departure) || from.isSame(arrival)) {
          dynamicDays.push(day);
          // ALSO CHECK AVAILABILITY
          if (day.availableRooms === 0) {
            room.available = false;
            const hint = 'Zimmer ist am '.concat(from.format('DD.MM.YYYY')).concat(' nicht verfügbar.');
            if (!this.containsHint(room, hint)) {
              room.hints.push(hint);
            }
          }
        }
      }

      if (room.available && !room.tooSmall) {
        let additionalAdults = request.adults > 2 ? request.adults - 2 : 0;
        // GET PRICE OF CHILDREN
        const children = [];
        if (kognitivRatePlan.childrenRules.length === 0 && request.children.length > 0) {
          if (!hotel.noChildren) {
            ratePlan.hints.push('Es sind keine Kinderregelungen für die Rate '.concat(kognitivRatePlan.name).concat(' definiert. Kinder werden als Zusatzgäste berechnet.'));
          }
          for (let i = 0; i < request.children.length; i += 1) {
            const child = request.children[i];
            additionalAdults += child.count;
            ratePlan.count.children += child.count;
          }
        } else if (kognitivRatePlan.childrenRules.length > 0 && request.children.length > 0) {
          kognitivRatePlan.childrenRules.sort(function(a, b){return a.age - b.age});
          for (let j = 0; j < request.children.length; j += 1) {
            const child = request.children[j];
            const childPrice = {
              count: child.count,
              age: child.age,
              price: undefined
            };
            for (let i = 0; i < kognitivRatePlan.childrenRules.length; i += 1) {
              const rule = kognitivRatePlan.childrenRules[i];
              if (child.age <= rule.age) {
                childPrice.price = rule.price;
                break;
              }
            }
            if (childPrice.price === undefined) {
              additionalAdults += 1;
            } else {
              children.push(childPrice);
            }
          }
        }
        ratePlan.children = children;
        // ADD CHILDREN TO TOTAL
        for (let i = 0; i < ratePlan.children.length; i += 1) {
          const child = ratePlan.children[i];
          ratePlan.total += ((child.count * child.price) * result.nights );
          ratePlan.count.children += child.count;
        }
        // ADD ADDITIONAL GUESTS
        if (additionalAdults > 0 && kognitivRatePlan.additionalGuestPrice > 0) {
          ratePlan.additional = {
            guests: additionalAdults,
            price: kognitivRatePlan.additionalGuestPrice
          };
          // ADD TO TOTAL
          ratePlan.total += (ratePlan.additional.guests * ratePlan.additional.price);
        } else if (additionalAdults > 0 && kognitivRatePlan.additionalGuestPrice === 0) {
          ratePlan.additional = {
            guests: additionalAdults,
            price: 0
          };
        }

        for (let i = 0; i < dynamicDays.length; i += 1) {
          const day = dynamicDays[i];
          ratePlan.adults += day.price;
        }
        ratePlan.total += ratePlan.adults;

        ratePlan.count.additional = additionalAdults;
      }
    },
    containsHint(room, hint) {
      let contains = false;
      for (let i = 0; i < room.hints.length; i += 1) {
        const roomHint = room.hints[i];
        if (roomHint === hint) {
          contains = true;
          break;
        }
      }
      return contains;
    }
  },
}